import { useDispatch, useSelector } from "react-redux";
import { CAREER_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import moment from "moment";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";
import { Button } from "@mui/material";
import { FaFileDownload } from "react-icons/fa";
import { FaFileUpload } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";
import {
  addCvCareerAction,
  deleteCvCareerAction,
} from "../../../redux/actions/careerActions";
import { useState } from "react";
import { MdDeleteOutline } from "react-icons/md";

const CareerCard = ({ data, mode, cellNumber, setOpenMoreModal }) => {
  const dispatch = useDispatch();
  const { careerData, lastPage } = useSelector(
    (state) => state.careerPagination
  );
  const { careerSearchValues } = useSelector((state) => state.searchValues);
  const [pdfError, setPdfError] = useState("");
  const {
    whereComingList: dataList,
    whereSendList,
    studentStatus,
  } = useCustomHook();
  console.log(
    data,
    "ddddddddddddddddddddddddddddddddddddddd===================="
  );
  const status = studentStatus.find(
    (status) => status.key === data.status
  )?.value;

  const whereComingName =
    dataList.find((item) => item.key === data.whereComing)?.name || "";
  const whereSendName =
    whereSendList.find((item) => item.key === data.whereSend)?.name || "";

  const workStatus =
    Array.isArray(data.workStatus) && data.workStatus.length > 0
      ? data.workStatus
          .map((workStatus) => {
            return workStatus.name;
          })
          .join(",")
      : "";

  const listData = [
    { key: "Qrup", value: data?.group?.name },
    { key: "İxtisas", value: data?.group?.course?.name },
    // { key: "Tələbənin adı", value: data.fullName },
    { key: "Portfolio linki", value: data?.portfolioLink || "" },
    { key: "CV linki", value: data?.cvLink || "" },
    { key: "Mobil Nömrə", value: data.phone },
    {
      key: "Müqavilə başlama tarixi",
      value: data?.contractStartDate
        ? moment(data?.contractStartDate).locale("az").format("DD MMMM YYYY")
        : "",
    },
    {
      key: "Müqavilə bitmə tarixi",
      value: data?.contractEndDate
        ? moment(data?.contractEndDate).locale("az").format("DD MMMM YYYY")
        : "",
    },
    { key: "Status", value: data.status ? "Davam edir" : "Məzun" },
    { key: "Diplom", value: "" },
  ];

  const handleDownload = async () => {
    const url = "http://localhost:4000" + data.cvLink;
    const fileName = data.fullName + "_Cv";

    try {
      const res = await fetch(url, { mode: "cors" });
      if (!res.ok) throw new Error("Network response was not ok");
      const blob = await res.blob();

      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const safeName = String(fileName).replace(/[^\w\-]+/g, "_");

      a.download = `${safeName}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch (e) {
      window.open(url, "_blank", "noopener,noreferrer");
    } finally {
    }
  };

  const onPickPdf = (e) => {
    const file = e.target.files?.[0];
    setPdfError("");

    if (file.type !== "application/pdf") {
      setPdfError("Yalnız PDF faylı yükləyə bilərsiniz.");
      return;
    }

    const fd = new FormData();
    fd.append("pdf", file);

    dispatch(addCvCareerAction(data.studentId, data.group._id, fd));
  };

  const deleteCv = (e) => {
    dispatch(deleteCvCareerAction(data.studentId, data.group._id));
  };

  const updateItem = (modalType) => {
    dispatch({
      type: CAREER_MODAL_ACTION_TYPE.GET_CAREER_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };
  const deleteItem = () => {
    const pageNumber =
      lastPage > 1 ? (careerData.length > 1 ? lastPage : lastPage - 1) : 1;
    const _id = data._id;
    const searchQuery = careerSearchValues;
    // dispatch(deleteCareerAction({ _id, pageNumber, searchQuery }));
  };
  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const doubleClick = () => {
    updateItem("");
  };

  return (
    <>
      {mode === "desktop" ? (
        <tr onDoubleClick={doubleClick}>
          <td>
            <div className="td-con">
              <div className="cell-number">{cellNumber}.</div>
              <div className="table-scroll-text phone">{data.fullName}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">{data?.group?.name}</div>
            </div>
          </td>
          <td className="email">
            <div className="td-con">
              <div className="table-scroll-text">
                {data?.group?.course?.name}
              </div>
            </div>
          </td>
          <td style={{ minWidth: "150px", wordBreak: "break-word" }}>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data.portfolioLink}
              </div>
            </div>
          </td>
          <td style={{ minWidth: "150px", wordBreak: "break-word" }}>
            <div className="td-con">
              <div
                className="table-scroll-text phone"
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "10px",
                    textTransform: "revert",
                    padding: "3px 6px",
                  }}
                  onClick={handleDownload}
                  disabled={!data.cvLink}
                >
                  Endir
                  <FaFileDownload
                    style={{ marginLeft: "8px", fontSize: "12px" }}
                  />
                </Button>

                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    fontSize: "10px",
                    textTransform: "revert",
                    padding: "3px 6px",
                  }}
                >
                  Əlavə et
                  <FaFilePdf style={{ marginLeft: "8px", fontSize: "12px" }} />
                  <input
                    type="file"
                    accept="application/pdf"
                    hidden
                    onChange={onPickPdf}
                  />
                </Button>

                <MdDeleteOutline
                  style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                  onClick={deleteCv}
                />

                <span>{pdfError}</span>
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">{data?.phone}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">{data?.fin}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">{data?.seria}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.birthday
                  ? moment(data?.birthday).locale("az").format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.group
                  ? moment(data?.group?.startDate)
                      .locale("az")
                      .format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.group
                  ? moment(data?.group?.endDate)
                      .locale("az")
                      .format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">{whereComingName}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">{whereSendName}</div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.previousWorkPlace}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.previousWorkPosition}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.currentWorkPlace}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.currentWorkPosition}
              </div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text phone">
                {data?.workStartDate
                  ? moment(data?.workStartDate)
                      .locale("az")
                      .format("DD MMMM YYYY")
                  : ""}
              </div>
            </div>
          </td>
          <td
            style={
              data.workStatus === "student"
                ? { backgroundColor: "#d2c3fe" }
                : data.workStatus === "employed"
                ? { backgroundColor: "#d4ffbf" }
                : data.workStatus === "unemployed"
                ? { backgroundColor: "#ffced1" }
                : {}
            }
          >
            <div className="td-con">
              <div className="table-scroll-text no-wrap">
                {workStatus}
                {/* {dataList.find((item) => item.key === data.workStatus)?.name ||
                  ""} */}
              </div>
            </div>
          </td>
          <td
            style={
              data.status === "graduate"
                ? { backgroundColor: "#d4ffbf" }
                : data.status === "continue"
                ? { backgroundColor: "#d2c3fe" }
                : data.status === "freeze"
                ? { backgroundColor: "var(--tertiary-300)" }
                : { backgroundColor: "var(--error-200)" }
            }
          >
            <div className="td-con  ">
              <div className="table-scroll-text phone">
                {data?.status ? status : ""}
              </div>
              {/*  */}
            </div>
          </td>
          <td>
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              openMoreModal={openMoreModal}
              profil={"careers"}
              data={data}
            />
          </td>
        </tr>
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{data.fullName}</h3>
            <ul>
              {listData.map((item, index) => (
                <li key={index}>
                  <span className="type">{item.key}</span>
                  <p>{item.value}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className="right">
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openMoreModal={openMoreModal}
              profil={"careers"}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CareerCard;
